import React, { useState } from "react";
import { Virtuoso, VirtuosoGrid } from "react-virtuoso";

const Skeleton = ({ h }) => <div className="animate-pulse bg-slate-800/40 rounded-lg my-1" style={{ height: h - 8 }} />;

/** Windowed list for capped-height panels: renders only visible rows (+~5 rows overscan), recycles nodes,
 *  and shows skeleton rows while the user scroll-seeks fast. */
export function VList({ items, maxHeight, rowHeight = 56, render, testid, keyOf = (x) => x.id }) {
  const [measured, setMeasured] = useState(0);  // real content height, so taller rows aren't hidden in a too-short box
  const height = Math.min(maxHeight, Math.max(rowHeight, measured || items.length * rowHeight));
  return (
    <Virtuoso style={{ height }} data={items} totalListHeightChanged={setMeasured} data-testid={testid} computeItemKey={(i, x) => keyOf(x)}
      increaseViewportBy={rowHeight * 5} defaultItemHeight={rowHeight}
      scrollSeekConfiguration={{ enter: (v) => Math.abs(v) > 2500, exit: (v) => Math.abs(v) < 200 }}
      components={{ ScrollSeekPlaceholder: () => <Skeleton h={rowHeight} /> }}
      itemContent={(i, x) => render(x, i)} />
  );
}

export function VGrid({ items, render, listClassName, testid, keyOf = (x) => x.id }) {
  return (
    <VirtuosoGrid useWindowScroll data={items} data-testid={testid} listClassName={listClassName}
      computeItemKey={(i, x) => keyOf(x)} increaseViewportBy={400} itemContent={(i, x) => render(x, i)} />
  );
}
